import { Stack, styled } from "@mui/material";

export const RecommendationsContainer = styled(Stack)`
  text-align: initial;
`;
